export const formatMessage = (
  messageTemplate: string | undefined,
  valuesToInject: Record<string, string | number>
) => {
  if (!messageTemplate) return '';
  return Object.keys(valuesToInject).reduce(
    (sentence, valueKey) =>
      sentence.replace(`{${valueKey}}`, valuesToInject[valueKey].toString()),
    messageTemplate
  );
};
